import script from "./HomePageEventsThisWeek.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePageEventsThisWeek.vue?vue&type=script&setup=true&lang=js"

import "./HomePageEventsThisWeek.vue?vue&type=style&index=0&id=4df68d8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4df68d8d"]])

export default __exports__